import React from 'react'
import './Navbar.css'
import { NavLink } from 'react-router-dom'
import { useLocation } from 'react-router-dom';

const IsActive = (path) => {
    const location = useLocation();
    return location.pathname === path;
};

function Navbar(props){
    return(
    
    <nav className='Nav-container'>
        <div className='grid-container' >
            <input className='nav-items input' type='checkbox' id='sidebar-active'></input>
            <label className='open-sidebar' for="sidebar-active">
                <svg className='nav-items menu-icon' xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#5f6368"><path d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"/></svg>
            </label>

            <label id="overlay" for='sidebar-active'></label>
            <div className='nav-items-container'>
                <ul className='nav-items ' >
                    <li className={`nav-item nav-item-${IsActive('/') ? 'active' : ''} home nav-button`}>
                        <NavLink className = 'link' to='/' >
                        <svg className='icons' xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#5f6368"><path d="M240-200h120v-240h240v240h120v-360L480-740 240-560v360Zm-80 80v-480l320-240 320 240v480H520v-240h-80v240H160Zm320-350Z"/></svg>
                        <h2 >Home</h2>
                        </NavLink>
                    </li>
                    <li className={`nav-item nav-item-${IsActive('/about_us') ? 'active' : ''} about_us nav-button`}>
                        <NavLink className = 'link' to='/about_us' >
                        <svg className='icons' xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#5f6368"><path d="M360-80v-529q-91-24-145.5-100.5T160-880h80q0 83 53.5 141.5T430-680h100q30 0 56 11t47 32l181 181-56 56-158-158v478h-80v-240h-80v240h-80Zm120-640q-33 0-56.5-23.5T400-800q0-33 23.5-56.5T480-880q33 0 56.5 23.5T560-800q0 33-23.5 56.5T480-720Z"/></svg>
                        <h2>About Us</h2>
                        </NavLink>
                    </li>
                    <li className={`nav-item nav-item-${IsActive('/products') ? 'active' : ''} products nav-button`}>
                        <NavLink className = 'link' to='/products' >
                        <svg className='icons' xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#5f6368"><path d="M200-80q-33 0-56.5-23.5T120-160v-451q-18-11-29-28.5T80-680v-120q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v120q0 23-11 40.5T840-611v451q0 33-23.5 56.5T760-80H200Zm0-520v440h560v-440H200Zm-40-80h640v-120H160v120Zm200 280h240v-80H360v80Zm120 20Z"/></svg>
                        <h2>Products</h2>
                        </NavLink>
                    </li>
                    <li className={`nav-item nav-item-${IsActive('/gallery') ? 'active' : ''} gallery nav-button`}>
                        <NavLink className = 'link' to='/gallery' >
                        <svg className='icons' xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#5f6368"><path d="M120-200q-33 0-56.5-23.5T40-280v-400q0-33 23.5-56.5T120-760h400q33 0 56.5 23.5T600-680v400q0 33-23.5 56.5T520-200H120Zm600-320q-17 0-28.5-11.5T680-560v-160q0-17 11.5-28.5T720-760h160q17 0 28.5 11.5T920-720v160q0 17-11.5 28.5T880-520H720Zm40-80h80v-80h-80v80ZM120-280h400v-400H120v400Zm40-80h320L375-500l-75 100-55-73-85 113Zm560 160q-17 0-28.5-11.5T680-240v-160q0-17 11.5-28.5T720-440h160q17 0 28.5 11.5T920-400v160q0 17-11.5 28.5T880-200H720Zm40-80h80v-80h-80v80Zm-640 0v-400 400Zm640-320v-80 80Zm0 320v-80 80Z"/></svg>
                        <h2>Gallery</h2>
                        </NavLink>
                    </li>
                    <li className={`nav-item nav-item-${IsActive('/order') ? 'active' : ''} order nav-button`}>
                        <NavLink className = 'link' to='/order' >
                        <svg className='icons' xmlns="http://www.w3.org/2000/svg" height="32px" viewBox="0 -960 960 960" width="32px" fill="#5f6368"><path d="M120-200q-33 0-56.5-23.5T40-280v-400q0-33 23.5-56.5T120-760h400q33 0 56.5 23.5T600-680v400q0 33-23.5 56.5T520-200H120Zm600-320q-17 0-28.5-11.5T680-560v-160q0-17 11.5-28.5T720-760h160q17 0 28.5 11.5T920-720v160q0 17-11.5 28.5T880-520H720Zm40-80h80v-80h-80v80ZM120-280h400v-400H120v400Zm40-80h320L375-500l-75 100-55-73-85 113Zm560 160q-17 0-28.5-11.5T680-240v-160q0-17 11.5-28.5T720-440h160q17 0 28.5 11.5T920-400v160q0 17-11.5 28.5T880-200H720Zm40-80h80v-80h-80v80Zm-640 0v-400 400Zm640-320v-80 80Zm0 320v-80 80Z"/></svg>
                        <h2>Order Now</h2>
                        </NavLink>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    )
}


export default Navbar
